/**
 * Elevante.AI Official Logo Component
 *
 * Renders the master Elevante wordmark+icon PNG. Kept under the original
 * `ElevanteLogoSVG.jsx` name so all existing imports continue to work; the
 * `invertColors` prop is now a no-op (the PNG ships in its final, dark-bg
 * compatible artwork already) but is preserved so callers don't have to
 * change.
 */

import React from 'react';

const ElevanteLogoSVG = ({ className = "h-12 w-auto", invertColors = false }) => {
  // `invertColors` retained as a no-op for API compatibility — the new
  // artwork is purpose-designed for the dark sidebar and looks correct on
  // light surfaces too.
  void invertColors;
  return (
    <img
      src="/elevante-logo.png"
      alt="Elevante.AI"
      className={className}
      draggable={false}
    />
  );
};

export default ElevanteLogoSVG;
